<script>
import Dropdown from 'element-ui/lib/dropdown';

export default Dropdown;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/dropdown.css';
// @import "../../stylesheets/utils/utils";
.el-popper .popper__arrow {
  direction: ltr;
}
</style>
